export function formatEuros(cents: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

/**
 * Extrait la date civile d'une valeur serveur. Accepte 'AAAA-MM-JJ' comme un
 * horodatage ISO complet : une valeur inattendue ne doit jamais faire planter
 * le rendu, un `Intl.format` sur une date invalide levant une RangeError qui
 * emporterait toute la page.
 */
function civilDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
  if (!match) return null;
  const parsed = new Date(`${match[1]}-${match[2]}-${match[3]}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function shortDate(value: string): string {
  const date = civilDate(value);
  if (!date) return value ?? '';
  return new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
}

export function longDate(value: string): string {
  const date = civilDate(value);
  if (!date) return value ?? '';
  return new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
}

export function localDate(): string {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}
